import api from "../api/api";

import { Creators as Actions, Types } from "ducks/Romaneios";
import { Creators as ActionsGeral } from "ducks/Geral";

import { verificarDestinatariosAssociados } from "actions/Destinatarios";

import { all, call, fork, put, takeLatest, take } from "redux-saga/effects";

import { VERIFICAR_DESTINATARIOS_ASSOCIADOS_SUCESSO } from "constants/ActionTypes";

import moment from "moment";

import notify from 'utils/modern_notify';

let mensagemRomaneios = "";

const buscarPesquisaRomaneiosRequisicao = async dados =>
    api
        .post("/api/romaneios/pesquisar/", dados)
        .then(PesquisaRomaneiosData => PesquisaRomaneiosData)
        .catch(error => error);

const deletarRomaneiosRequisicao = async dados =>
    api
        .delete("/api/romaneios/deletar", dados)
        .then(response => response)
        .catch(error => error);

const buscarNotasRomaneiosRequisicao = async dados =>
    api
        .get("/api/notas/busca/porchave", dados)
        .then(buscarNotas => buscarNotas)
        .catch(error => error);

const buscarGerarRomaneiosAutomaticoRequisicao = async dados =>
    await api
        .post("/api/romanear", dados)
        .then(romaneiosData => romaneiosData)
        .catch(error => error);

const notasvalidarRomaneiosRequisicao = async dados =>
    api
        .get(`api/romaneios/pre/buscar/`, dados)
        .then(buscarRomaneioValidar => buscarRomaneioValidar)
        .catch(error => error);

const validarRomaneiosRequisicao = async dados =>
    api
        .post("api/romaneios/pre/validar", dados)
        .then(buscarRomaneioValidar => buscarRomaneioValidar)
        .catch(error => error);

const atualizarRomaneiosRequisicao = async dados =>
    api
        .put("/api/romaneios/editar", dados)
        .then(criarRomaneios => criarRomaneios)
        .catch(error => error);

const posicaoNotasromRequisicao = async dados =>
    api
        .post("api/posicaoauto", dados)
        .then(buscarRomaneioValidar => buscarRomaneioValidar)
        .catch(error => error);

function* validarRomApp({ payload }) {
    const { cnpjEmpresa, numerosRom } = payload;

    mensagemRomaneios = "";

    let dados = {
        cnpjEmpresa,
        numerosRom
    };

    let romaneiosValidado = [];

    try {
        const response = yield call(validarRomaneiosRequisicao, dados);

        if (response.ok) {
            if (response.data.resultado) {
                romaneiosValidado = response.data;
                yield put(
                    Actions.validarRomAppSucesso({
                        numerosRom,
                        romaneiosValidado
                    })
                );
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        mensagemRomaneios = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                mensagemRomaneios = "Ocorreu um erro interno.Tente novamente";
            }

            // yield put(
            //     ActionsGeral.setMensagem({
            //         mensagem: mensagemRomaneios,
            //         mostrar: true
            //     })
            // );
            notify(mensagemRomaneios)
        }
    } catch (error) {
        console.log(error);
    }
}

function* buscaRomValidar({ payload }) {
    mensagemRomaneios = "";

    let buscarRomaneioValidar = [];

    const { cnpj_empresa, bases, semBase } = payload;

    try {
        const response = yield call(notasvalidarRomaneiosRequisicao, {
            cnpj_empresa,
            bases,
            semBase
        });

        if (response.ok) {
            if (response.data.resultado) {
                buscarRomaneioValidar = response.data.valor;
            }

            yield put(Actions.buscaRomValidarSucesso(buscarRomaneioValidar));
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        mensagemRomaneios = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                mensagemRomaneios = "Ocorreu um erro interno.Tente novamente";
            }
        }
    } catch (error) {
        console.log(error);
    }
}

function* buscarRomaneios({ payload }) {
    const { cnpjEmpresa, bases, sembase, filtros } = payload;

    const dados = {
        cnpj_empresa: cnpjEmpresa ? cnpjEmpresa : "",
        numero_romaneio: filtros.numeroRomaneio ? filtros.numeroRomaneio : null,
        cpf_motorista: filtros.motorista ? filtros.motorista : null,
        dataInicio: filtros.dataInicio ? filtros.dataInicio : null,
        dataFim: filtros.dataFim ? filtros.dataFim : null,
        bases: bases,
        sembase: sembase
    };

    let PesquisaRomaneiosData = [];

    mensagemRomaneios = "Error romaneios";

    const response = yield call(buscarPesquisaRomaneiosRequisicao, dados);

    if (response.ok) {
        if (response.data.resultado) {
            PesquisaRomaneiosData = response.data.valor.map(romaneiosBusca => ({
                data: romaneiosBusca.created_at
                    ? romaneiosBusca.created_at
                    : null,
                numeroRomaneio: romaneiosBusca.numero_romaneio
                    ? romaneiosBusca.numero_romaneio
                    : "",
                nomeEmpresa: romaneiosBusca.nome_empresa
                    ? romaneiosBusca.nome_empresa
                    : "",
                criadorRomaneios: romaneiosBusca.criador_romaneio
                    ? romaneiosBusca.criador_romaneio
                    : "",
                unidade: romaneiosBusca.unidade_romaneio
                    ? romaneiosBusca.unidade_romaneio
                    : "",
                cpfMotorista: romaneiosBusca.cpf_motorista
                    ? romaneiosBusca.cpf_motorista
                    : "",
                placa_veiculo: romaneiosBusca.placa_veiculo
                    ? romaneiosBusca.placa_veiculo
                    : "",
                motorista: romaneiosBusca.nome_motorista
                    ? romaneiosBusca.nome_motorista
                    : "",
                totalNotas: romaneiosBusca.total_notas
                    ? romaneiosBusca.total_notas
                    : "",
                id: romaneiosBusca._id ? romaneiosBusca._id : "",
                totalVolume: romaneiosBusca.total_volumes
                    ? romaneiosBusca.total_volumes
                    : 0,
                totalValor: romaneiosBusca.total_valor
                    ? romaneiosBusca.total_valor
                    : 0
            }));

            yield put(Actions.buscarRomaneiosSucesso(PesquisaRomaneiosData));
        } else {
            notify("Sem romaneios para essas informacoes.",1)
        }
    } else {
        if (response.data.hasOwnProperty("error")) {
            switch (response.data.error) {
                default:
                    mensagemRomaneios =
                        "Não foi possível gerar romaneios [205]";
                    break;
            }
        } else {
            mensagemRomaneios = "Sem dados para exibir";
        }

        yield put(Actions.setLoadGerarRomaneios({ loader: false }));
    }

    yield put(Actions.setLoad(false));
}

function* buscarNotas({ payload }) {
    const { cnpjEmpresa, formBipe } = payload;

    const dados = {
        cnpjTomador: cnpjEmpresa ? cnpjEmpresa : "",
        chaveNota: formBipe ? formBipe : ""
    };

    let buscarNotas = [];

    mensagemRomaneios = "Error romaneios";

    const response = yield call(buscarNotasRomaneiosRequisicao, dados);
    if (response.ok) {
        if (response.data.resultado) {
            buscarNotas = response.data.valor;
            yield put(Actions.buscarNotasSucesso(buscarNotas));
        } else if (response.data.valor === []) {
            mensagemRomaneios = "Sem dados para exibir";
        }
    } else {
        if (response.data.hasOwnProperty("error")) {
            switch (response.data.error) {
                default:
                    mensagemRomaneios =
                        "Não foi possível gerar romaneios [205]";
                    break;
            }
        } else {
            mensagemRomaneios = "Sem dados para exibir";
        }

        yield put(Actions.setLoadGerarRomaneios({ loader: false }));
    }

    yield put(Actions.setLoadGerarRomaneios({ loader: false }));
}

function* deletarRomaneios({ payload }) {
    const dados = payload;

    mensagemRomaneios = "";

    try {
        const response = yield call(deletarRomaneiosRequisicao, dados);

        if (response.ok) {
            yield put(Actions.deletarRomaneiosSucesso(dados));
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default: {
                        mensagemRomaneios = `Ocorreu um erro${response.data.error}`;
                        break;
                    }
                }
            } else {
                mensagemRomaneios = "Ocorreu um erro interno.Tente novamente";
            }

            yield put(Actions.mostrarMensagem(mensagemRomaneios));
        }
    } catch (error) {
        yield put(Actions.mostrarMensagem("Erro: 25-4"));
    }
}

function* buscarGerarRomaneios({ payload }) {
    const {
        datas,
        cnpjEmpresa,
        rotas,
        cnpjsEmpresa,
        cnpjs,
        grupo_emp
    } = payload;

    mensagemRomaneios = "";

    try {
        yield put(
            verificarDestinatariosAssociados({
                cnpjEmpresa: cnpjsEmpresa
            })
        );

        const result = yield take([VERIFICAR_DESTINATARIOS_ASSOCIADOS_SUCESSO]);

        if (result.type === VERIFICAR_DESTINATARIOS_ASSOCIADOS_SUCESSO) {
            yield call(acaoGerarRomaneios, {
                datas: {
                    dataInicio: datas.startDate,
                    dataFim: datas.endDate
                },
                cnpjEmpresa,
                cnpjs,
                grupo_emp,
                rotas
            });
        } else {
            yield put(Actions.setLoadGerarRomaneios({ loader: false }));
        }
    } catch (error) {
        yield put(Actions.setLoadGerarRomaneios({ loader: false }));
        notify(`Erro gerar romaneios resposta ${error}`)
    }
}

function* acaoGerarRomaneios(dados) {
    const { datas, cnpjEmpresa, rotas, cnpjs, grupo_emp } = dados;
    let romaneiosData = [];

    mensagemRomaneios = "Error romaneios";

    const response = yield call(buscarGerarRomaneiosAutomaticoRequisicao, {
        cnpjs,
        grupo_emp,
        cnpjEmpresa,
        dataInicio: moment(datas.dataInicio).format("YYYYMMDDHHmm"),
        dataFim: moment(datas.dataFim).format("YYYYMMDDHHmm"),
        rotas
    });

    if (response.ok) {
        if (response.data.resultado) {
            if (response.data.romaneios.hasOwnProperty("romaneiosCriados")) {
                if (response.data.romaneios.hasOwnProperty("criados")) {
                    let romaneios = response.data.romaneios.criados;

                    Object.keys(romaneios).forEach(key => {
                        const romaneio = romaneios[key];
                        romaneiosData.push({
                            _id: key,
                            romaneio: romaneio.numero_romaneio || "",
                            cpf: romaneio.cpf_motorista || "",
                            motorista: romaneio.cpf_motorista || "",
                            dataCriacao: romaneio.created_at || "",
                            totalNotas: romaneio.total_notas_romaneio || "",
                            unidade: romaneio.unidade_romaneio | "",
                            cnpjEmpresa: romaneio.cnpj_empresa || "",
                            rota: romaneio.rotaPertencente || "",
                            volume: romaneio.qtd_volumes_romaneio || 0,
                            idRota: romaneio.id_rota || ""
                        });
                    });

                    yield put(Actions.gerarRomaneiosSucesso(romaneiosData));
                }
            }
        } else {
            let msg = "Não foi possível criar os romaneios - " + response.data.erro
                ? response.data.erro
                : ""
            notify(msg)
        }
    } else {
        if (response.data.hasOwnProperty("error")) {
            switch (response.data.error) {
                default:
                    mensagemRomaneios =
                        "Não foi possível gerar romaneios [205]";
                        notify(mensagemRomaneios)
                    break;
            }
        } else {
            mensagemRomaneios = "Sem dados para exibir";
            notify(mensagemRomaneios,1)
        }

        yield put(Actions.setLoadGerarRomaneios({ loader: false }));
    }

    yield put(Actions.setLoadGerarRomaneios({ loader: false }));
}

function* atualizarRomaneios({ payload }) {
    const { cnpjEmpresa } = payload;
    const {
        dados,
        BuscarRomaneios,
        numero_romaneio,
        created_at,
        total_notas_romaneio,
        grupo_emp,
        criador
    } = payload;

    mensagemRomaneios = "";

    let romaneiosAtualizado = [];
    let arrayNotasRomaneio = [];
    let arrayNotasExcluida = [];

    arrayNotasRomaneio = dados.notasRomaneioEditar.map((nota, index) => {
        let dados = {
            ar_nota: nota.ar_nota ? nota.ar_nota : "",
            pos_entrega: nota.pos_entrega,
            index: nota.pos_entrega,
            cnpj_dist: nota.cnpj_dist ? nota.cnpj_dist : "",
            serie_nota: nota.serie_nota ? nota.serie_nota : "",
            numero_nota: nota.numero_nota ? nota.numero_nota : "",
            chave_nota: nota.chave_nota ? nota.chave_nota : "",
            acao: nota.acao ? nota.acao : "",
            nome_destinatario: nota.nome_destinatario
                ? nota.nome_destinatario
                : "",
            cnpj_destinatario: nota.cnpj_destinatario
                ? nota.cnpj_destinatario
                : "",
            qtd_volumes: nota.qtd_volumes ? nota.qtd_volumes : "",
            valor_mercadoria: nota.valor_mercadoria
                ? nota.valor_mercadoria
                : "",
            end_dest: nota.end_dest ? nota.end_dest : ""
        };
        if (nota.acao === "adicionar") {
            dados = {
                ...dados,
                cnpj_transp: nota.cnpj_transp ? nota.cnpj_transp : "",
                end_dest: nota.end_dest ? nota.end_dest : "",
                nome_dist: nota.nome_dist ? nota.nome_dist : "",
                nome_transp: nota.nome_transp ? nota.nome_transp : "",
                numero_nota: nota.numero_nota ? nota.numero_nota : "",
                qtd_volumes: nota.qtd_volumes ? nota.qtd_volumes : "",
                valor_mercadoria: nota.valor_mercadoria
                    ? nota.valor_mercadoria
                    : "",
                tipo_doc: nota.tipo_doc ? nota.tipo_doc : ""
            };
        }

        return dados;
    });

    arrayNotasExcluida = dados.notasExcluidas.map((nota, index) => {
        let dados = {
            ar_nota: nota.arNota ? nota.arNota : "",
            acao: nota.acao ? nota.acao : ""
        };
        return dados;
    });

    var notas = arrayNotasRomaneio.concat(arrayNotasExcluida);

    const AtualizarRomaneio = {
        cnpj_empresa: cnpjEmpresa ? cnpjEmpresa : "",
        cpf_motorista: BuscarRomaneios.initial.motorista.value
            ? BuscarRomaneios.initial.motorista.value
            : "",
        nome_motorista: BuscarRomaneios.initial.motorista.label
            ? BuscarRomaneios.initial.motorista.label
            : "",
        cpf_motorista_novo: BuscarRomaneios.values.motorista.value
            ? BuscarRomaneios.values.motorista.value
            : "",
        nome_motorista_novo: BuscarRomaneios.values.motorista.label
            ? BuscarRomaneios.values.motorista.label
            : "",
        placa_veiculo: BuscarRomaneios.values.numeroPlaca
            ? BuscarRomaneios.values.numeroPlaca
            : "",
        numero_romaneio,
        created_at,
        criador,
        grupo_emp,
        total_notas_romaneio,
        notas: notas
    };

    try {
        const response = yield call(
            atualizarRomaneiosRequisicao,
            AtualizarRomaneio
        );

        if (response.ok) {
            if (response.data.resultado === false) return false;

            romaneiosAtualizado = response.data;

            yield put(Actions.atualizarRomaneiosSucesso(romaneiosAtualizado));
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default: {
                        mensagemRomaneios = `Ocorreu um erro${response.data.error}`;
                        break;
                    }
                }
            } else {
                mensagemRomaneios = "Ocorreu um erro interno.Tente novamente";
            }

            notify(mensagemRomaneios)
        }
    } catch (error) {
        notify(`Erro Criar Romaneio: ${error}`)
    }
}

function* OrdArrayNtBusca({ payload }) {
    const dados = payload;

    mensagemRomaneios = "";

    try {
        const response = yield call(posicaoNotasromRequisicao, dados);

        if (response.ok) {
            yield put(Actions.OrdArrayNtBuscaSucesso(response.data));
        } else {
            notify("Sem romaneios para essas informações.",1)
        }

        if (response.data.resultado === false) {
            notify("Erro ao enviar dados de partida / ar_not")
        }
    } catch (error) {
        console.log(error);
    }
}

export function* buscarDadosGerarRomaneios() {
    yield takeLatest(Types.GERAR_ROMANEIOS, buscarGerarRomaneios);
}

export function* buscarDadosPesquisaRomaneio() {
    yield takeLatest(Types.BUSCAR_ROMANEIOS, buscarRomaneios);
}

export function* deletarDadosRomaneio() {
    yield takeLatest(Types.DELETAR_ROMANEIOS, deletarRomaneios);
}

export function* buscarDadosNotasRomaneio() {
    yield takeLatest(Types.BUSCAR_NOTAS, buscarNotas);
}

export function* AtualizarDadosRomaneios() {
    yield takeLatest(Types.ATUALIZAR_ROMANEIOS, atualizarRomaneios);
}

export function* buscarDadosValidarRomaneio() {
    yield takeLatest(Types.BUSCA_ROM_VALIDAR, buscaRomValidar);
}

export function* validarDadosRomaneioApp() {
    yield takeLatest(Types.VALIDAR_ROM_APP, validarRomApp);
}

export function* OrdArrayDadosNtBusca() {
    yield takeLatest(Types.ORD_ARRAY_NT_BUSCA, OrdArrayNtBusca);
}

export default function* rootSaga() {
    yield all([
        fork(buscarDadosPesquisaRomaneio),
        fork(deletarDadosRomaneio),
        fork(buscarDadosNotasRomaneio),
        fork(buscarDadosGerarRomaneios),
        fork(AtualizarDadosRomaneios),
        fork(buscarDadosValidarRomaneio),
        fork(validarDadosRomaneioApp),
        fork(OrdArrayDadosNtBusca)
    ]);
}
